import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useTranslation } from 'react-i18next';

/**
 * Les boutons de partage de la vitrine.
 *
 * 🔑 `aria-label` en français, explicitement. react-share 5 pose désormais un
 * nom accessible lui-même — c'est un progrès sur la v4, qui rendait des boutons
 * réduits à une icône, donc muets — mais il le pose EN ANGLAIS : « Share on
 * Facebook ». Sur un produit en français canadien, une personne au lecteur
 * d'écran entendrait trois libellés anglais au milieu de son interface.
 */
export default function SocialMediaButtons({ url, quote, hashtags }) {
  const { t } = useTranslation('myBooks');

  return (
    <>
      {/* ⛔ Pas de `quote` : react-share 5 l'a retirée de `FacebookShareButton`,
          qui ne construit plus que `{u, hashtag}`. La prop retombait telle
          quelle dans le DOM, en attribut invalide sur un <button>. Facebook a
          de toute façon cessé de l'honorer depuis des années — mais une prop
          qui ne fait rien et qu'on croit active est pire que son absence. */}
      <FacebookShareButton
        url={url}
        hashtag={`#${hashtags?.[0]}`}
        aria-label={t('share_modal.boutons.facebook')}
      >
        <FacebookIcon color="primary" fontSize="large" />
      </FacebookShareButton>
      {/* ⚠️ `TwitterShareButton` est déprécié en v5 au profit de
          `XShareButton`. Il fonctionne encore et le lien reste le bon ; on ne
          change pas de composant au milieu d'une migration. À reprendre avec
          l'icône, qui montre encore l'oiseau alors que le libellé dit « X ». */}
      <TwitterShareButton
        url={url}
        title={`${quote}\n\n ➡ `}
        hashtags={hashtags}
        aria-label={t('share_modal.boutons.twitter')}
      >
        <TwitterIcon color="primary" fontSize="large" />
      </TwitterShareButton>
      <WhatsappShareButton
        url={url}
        title={quote}
        separator={'\n\n ➡ '}
        aria-label={t('share_modal.boutons.whatsapp')}
      >
        <WhatsAppIcon color="primary" fontSize="large" />
      </WhatsappShareButton>
    </>
  );
}
